// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mReasonAutoAcceptUnavailable {\n  color: #d02c1c;\n}\n", ""]);
// Exports
module.exports = exports;
